// extracted by mini-css-extract-plugin
export default {"navigation":"SwiperNavigation_navigation__tNYnn","navigation__prev":"SwiperNavigation_navigation__prev__o+k+5","navigation__next":"SwiperNavigation_navigation__next__V31g1"};